import React from 'react';
import PropTypes from 'prop-types';

import './store-services.scss';

export default function StoreServices(props) {
  const { servicesList } = props;
  return (
    <ul data-testid={'mainlst'} styleName="service-list">
      {servicesList &&
        servicesList.map((service, idx) => (
          <li
            data-testid={`lst-${idx}`}
            key={`ss-${idx}`}
            styleName="service-list-item"
          >
            {service.name}
          </li>
        ))}
    </ul>
  );
}

StoreServices.propTypes = {
  servicesList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string
    })
  )
};
